import { RouteObject } from 'react-router';

import { DefaultLayout } from '@/ui/pages/app/components/layouts/DefaultLayout';
import { VenueDates } from '@/ui/pages/app/project/venue/dates/VenueDates';
import { VenueDefaultDatas } from '@/ui/pages/app/project/venue/default-datas/VenueDefaultDatas';
import { EditProjectVenue } from '@/ui/pages/app/project/venue/edit-project/EditProjectVenue';
import { VenuePresets } from '@/ui/pages/app/project/venue/presets/VenuePresets.tsx';
import { ProjectVenue } from '@/ui/pages/app/project/venue/project/ProjectVenue';
import { ProjectsVenue } from '@/ui/pages/app/project/venue/projects/ProjectsVenue';
import { VenueStructure } from '@/ui/pages/app/project/venue/structure/VenueStructure';

import {
  presetsLoader,
  venueDatesLoader,
  venueIndexLoader,
  venueLoader,
  venuesLoader,
  venueStructureLoader,
} from './venueLoaders';

export const venueRoutes: RouteObject[] = [
  {
    path: 'projects/venue',
    loader: venueIndexLoader,
    children: [
      {
        path: '',
        loader: venuesLoader,
        element: (
          <DefaultLayout>
            <ProjectsVenue />
          </DefaultLayout>
        ),
      },
      {
        path: ':id',
        loader: venueLoader,
        element: (
          <DefaultLayout>
            <ProjectVenue />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/edit',
        loader: venueLoader,
        element: (
          <DefaultLayout>
            <EditProjectVenue />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/structure',
        loader: venueStructureLoader,
        element: (
          <DefaultLayout>
            <VenueStructure />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/dates',
        loader: venueDatesLoader,
        element: (
          <DefaultLayout>
            <VenueDates />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/default-datas',
        loader: venueLoader,
        element: (
          <DefaultLayout>
            <VenueDefaultDatas />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/presets',
        loader: presetsLoader,
        element: (
          <DefaultLayout>
            <VenuePresets />
          </DefaultLayout>
        ),
      },
    ],
  },
];
